export default from './LinkButton';


/** WEBPACK FOOTER **
 ** ./app/components/linkButton/index.js
 **/